{
	"invalidListItem": "La valeur saisie n'est pas une option valide.",
	"invalidListTitle": "Valeur invalide",
	"selectAValidOption": "Veuillez sélectionner une option valide.",
	"selectAValue": "Sélectionner une valeur",
	"invalidValue": "La valeur saisie n'est pas valide.",
	"values": {
		"boolean": {
			"true": "Oui",
			"false": "Non"
		}
	}
}
